module.exports = __webpack_public_path__ + "img/frame (199).9282041e.jpg";